import React from 'react'
import PropTypes from 'prop-types'
import { SanitizeHTML } from '@tc-packages/tc-common'
import Button from './shared/Button'

// ImageWithText: A sub-component that renders an image along with some text content.
function ImageWithText({ section }) {
  return (
    <div className="textWithImage_row row">
      <div className="textWithImage_media col-lg-6">
        <img
          alt={section.image_alt}
          className="textWithImage_img"
          src={section.image_url}
        />
      </div>
      <div className="textWithImage_text col-lg-6">
        <h2 className={`textWithImage_title ${section.config.is_font_medium ? 'fw-medium' : 'fw-bold'}`}>
          {section.title}
        </h2>
        {section.subtitle.trim() !== '' && (
          <h3 className="textWithImage_title">{section.subtitle}</h3>
        )}
        <div className="textWithImage_body">
          <SanitizeHTML html={section.description} />
        </div>
        {section.button_url.trim() !== '' &&
          section.button_label.trim() !== '' && (
            <Button
              arrow={section.button_arrow}
              background={section.button_background}
              backgroundHover={section.button_background_hover}
              color={section.button_color}
              colorHover={section.button_color_hover}
              label={section.button_label}
              openInNewTab={section.link_open_in_new_tab}
              url={section.button_url}
            />
          )}
      </div>
    </div>
  )
}

ImageWithText.propTypes = {
  section: PropTypes.shape({
    button_arrow: PropTypes.string.isRequired,
    button_background: PropTypes.string.isRequired,
    button_background_hover: PropTypes.string.isRequired,
    button_color: PropTypes.string.isRequired,
    button_color_hover: PropTypes.string.isRequired,
    button_label: PropTypes.string.isRequired,
    button_url: PropTypes.string.isRequired,
    config: PropTypes.shape({
      is_font_medium: PropTypes.bool.isRequired,
    }).isRequired,
    description: PropTypes.string.isRequired,
    image_alt: PropTypes.string.isRequired,
    image_url: PropTypes.string.isRequired,
    link_open_in_new_tab: PropTypes.bool.isRequired,
    subtitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
}

// ContentImageSection: A component that displays an image along with some text content.
export default function ContentImageSection({ section }) {
  const { is_gray, is_gradient, layout } = section.config

  const sectionClasses = [
    layout === 'right' && 'imageRight',
    is_gray && 'section--grey',
    'textWithImage',
    is_gradient && 'textWithImageGradient',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <section className={sectionClasses} key={section.node_id}>
      <div className="textWithImage_container container contentWrapper_large">
        <ImageWithText section={section} />
      </div>
    </section>
  )
}

ContentImageSection.propTypes = {
  section: PropTypes.shape({
    button_arrow: PropTypes.string.isRequired,
    button_background: PropTypes.string.isRequired,
    button_background_hover: PropTypes.string.isRequired,
    button_color: PropTypes.string.isRequired,
    button_color_hover: PropTypes.string.isRequired,
    button_label: PropTypes.string.isRequired,
    button_url: PropTypes.string.isRequired,
    config: PropTypes.shape({
      is_gradient: PropTypes.bool.isRequired,
      is_gray: PropTypes.bool.isRequired,
      is_font_medium: PropTypes.bool.isRequired,
      layout: PropTypes.oneOf(['left', 'right']).isRequired,
    }).isRequired,
    description: PropTypes.string.isRequired,
    image_alt: PropTypes.string.isRequired,
    image_url: PropTypes.string.isRequired,
    link_open_in_new_tab: PropTypes.bool.isRequired,
    node_id: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
}
